module.exports = __webpack_public_path__ + "img/10.2ffbd822.png";